export default __webpack_public_path__ + "static/img-about-2-42d50679630c4a9381db1ec1b2a0c3ab.gif";